<template>
    <component :is="eqTemplates[data?.typeHandle]?.component || 'section'" :data="data" />
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        data?: CmsItem;
    }>(),
    {
        data: () => ({})
    }
);

const data = computed(() => props.data);

const cPageDefault = resolveComponent('TemplatesPageDefault');
const cPageContent = resolveComponent('TemplatesPageContent');
const cPageContentFull = resolveComponent('TemplatesPageContentFull');
const cPageNews = resolveComponent('TemplatesPageNews');

const eqTemplates: Record<string, { component: ReturnType<typeof resolveComponent> }> = {
    pageDefault: {
        component: cPageDefault
    },
    pageContent: {
        component: cPageContent
    },
    pageContentFull: {
        component: cPageContentFull
    },
    pageNews: {
        component: cPageNews
    }
};
</script>
